import ComboBox from "../core/ComboBox";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faCheck } from "@fortawesome/free-solid-svg-icons";

const POINT_VALUES = [0, 0.5, 1, 2, 3, 5, 8, 13];

const PointsDropdown = ({
  currentPointsValue = 0,
  showDropdown,
  onToggle,
  onClose,
  onSelect,
}) => {
  const normalizedPoints = Number(currentPointsValue) || 0;
  const pointOptions = POINT_VALUES.map((value) => ({
    point_value: value,
    name: value.toString(),
  }));

  const selectedPoint = pointOptions.find(
    (option) => option.point_value === normalizedPoints
  );

  const selectedItems = selectedPoint ? [selectedPoint] : [];

  return (
    <div className="inline-select">
      <button
        type="button"
        className="inline-select-trigger"
        onClick={(e) => {
          e.stopPropagation();
          onToggle();
        }}
      >
        <span className="inline-select-text">{normalizedPoints}</span>
        <FontAwesomeIcon
          icon={faChevronDown}
          className="inline-select-chevron"
        />
      </button>
      {showDropdown && (
        <div className="inline-select-dropdown">
          <ComboBox
            data={pointOptions}
            selected={selectedItems}
            valueKey="point_value"
            placeholder="Search points..."
            searchTopic="points"
            formatData={(option) => (
              <div className="inline-option">
                <span>{option.name}</span>
                {normalizedPoints === option.point_value && (
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="inline-option-check"
                  />
                )}
              </div>
            )}
            handleSelect={(pointsValue) => {
              onSelect(pointsValue);
              onClose();
            }}
            onRequestClose={onClose}
            inline={true}
          />
        </div>
      )}
    </div>
  );
};

export default PointsDropdown;
